import {createAction} from '@reduxjs/toolkit'

import {APIStatusType, ClosingTimingType} from '@web/core/constants'
import {LanguageType} from '@web/i18n'

/** 주문서 init 완료 여부 변경 액션 */
export const checkInitOrderSheetDone = createAction<void>('common/checkInitOrderSheetDone')

/** fetching api data 외의 수단으로 scene 변경시 scene 상태 적용 */
export const setScene = createAction<APIStatusType>('common/setScene')

/** backUrl 업데이트 */
export const setBackUrl = createAction<string>('common/setBackUrl')

/** 언어정보 업데이트 */
export const setLanguage = createAction<LanguageType>('common/setLanguage')

/** closingTiming 업데이트 (ex. "IMMEDIATE" | "DELAYED") */
export const setClosingTiming = createAction<ClosingTimingType>('common/setClosingTiming')
